export const translations = {
  es: {
    nav: { search: "Buscar Doctor", doctorLogin: "Soy doctor", patientLogin: "Soy paciente", patientSpace: "Mi espacio", admin: "Admin", dashboard: "Panel", logout: "Cerrar sesión", downloadApp: "Descargar app" },
    home: {
      title: "Citas médicas en 2 clics",
      subtitle: "Encuentra el mejor médico en tu ciudad de Ecuador. Reserva en segundos, sin llamadas ni esperas.",
      searchCta: "Buscar doctores",
      doctorCta: "Soy médico, empieza gratis",
      trialBadge: "30 días gratis, sin tarjeta · Al final agregue su método de pago: $49/mes",
      cityLabel: "Ciudad",
      specialtyLabel: "Especialidad",
      selectCity: "Selecciona ciudad",
      selectSpecialty: "Todas las especialidades",
      featuresTitle: "¿Por qué Agendik?",
      f1t: "Reserva instantánea", f1d: "Confirma tu cita en solo 2 clics. Sin llamadas ni esperas.",
      f2t: "Doctores verificados", f2d: "Profesionales certificados en todo Ecuador.",
      useLocation: "Usar mi ubicación",
      f3t: "Recordatorios por email", f3d: "Recibe confirmación y recordatorio 24 horas antes.",
      doctorsTitle: "Para médicos", doctorsSub: "Gestiona tu agenda, recibe pacientes y crece tu consulta.",
      trialCard: "$49/mes · 30 días gratis",
      priceMonth: "/mes",
      trialFull: "30 días gratis, sin tarjeta. Al final de la prueba, agregue su método de pago para continuar: $49/mes.",
      benefit1: "Agenda configurable (5 a 60 min)",
      benefit2: "Perfil público en Ecuador · 30 ciudades",
      benefit3: "Recordatorios automáticos",
      addToCalendar: "Añadir a mi calendario",
      dobLabel: "Fecha de nacimiento del familiar (DD/MM/AAAA)",
      calendarTab: "Mi calendario",
      addManual: "Añadir cita manual",
      pause: "Pausa",
      today: "Hoy",
      confirmed: "Confirmada",
      pending: "Pendiente",
    },
    footer: { terms: "Términos y Condiciones", privacy: "Política de Privacidad", manage: "Gestionar mi cita", becomePartner: "Conviértase en Socio referidor", about: "Sobre nosotros" },
    search: {
      title: "Encuentra tu médico",
      resultsTitle: "Resultados",
      noResults: "No hay doctores para esta búsqueda.",
      viewProfile: "Ver perfil",
    },
    profile: {
      about: "Acerca de", specialty: "Especialidad", clinic: "Clínica", address: "Dirección",
      phone: "Teléfono", availableSlots: "Horarios disponibles", pickDate: "Selecciona fecha",
      noSlots: "No hay horarios disponibles este día.", bookNow: "Reservar cita",
    },
    booking: {
      title: "Confirma tu reserva", step1: "Elige horario", step2: "Tus datos",
      fullName: "Nombre completo",
      holderName: "Tu nombre completo (titular de la cuenta)",
      email: "Email",
      holderEmail: "Tu email (recibirás la confirmación)",
      phone: "Teléfono",
      holderPhone: "Tu teléfono",
      notes: "Notas (opcional)", confirm: "Confirmar cita", back: "Atrás",
      success: "¡Cita confirmada!", successMsg: "Te enviamos los detalles a tu email.",
      close: "Cerrar",
      manageHint: "Para ver o cancelar su cita, use el enlace que le enviamos por email o 'Gestionar mi cita'.",
    },
    doctorAuth: {
      loginTitle: "Ingreso Doctor", registerTitle: "Registro Doctor",
      email: "Email", password: "Contraseña", passwordConfirm: "Confirmar contraseña",
      login: "Ingresar", register: "Crear cuenta",
      switchRegister: "¿No tienes cuenta? Regístrate", switchLogin: "¿Ya tienes cuenta? Ingresa",
      fullName: "Nombre completo", specialty: "Especialidad",
      specialtyPlaceholder: "Seleccione su especialidad",
      clinicName: "Nombre de clínica",
      address: "Dirección", city: "Ciudad", phone: "Teléfono",
      photoUrl: "Foto de perfil (opcional)", uploadPhoto: "Subir foto de perfil",
      senescyt: "Número de registro SENESCYT",
      diploma: "Título / certificado SENESCYT",
      uploadDiploma: "Subir título",
      uploadDiplomaHint: "Foto o PDF donde se vea el número de registro.",
      cedulaFront: "Cédula – frente",
      cedulaBack: "Cédula – reverso",
      uploadCedulaFront: "Subir frente",
      uploadCedulaBack: "Subir reverso",
      cedulaFrontHint: "Foto nítida (JPG/PNG, máx 5 MB).",
      cedulaBackHint: "Foto nítida (JPG/PNG, máx 5 MB).",
      changeFile: "Cambiar",
      cedulaHelper: "Las fotos de la cédula son privadas: sólo el administrador puede consultarlas mediante un enlace firmado temporal.",
      errCedulaRequired: "Debes subir la cédula (frente y reverso).",
      errDiplomaRequired: "Debes subir el título / certificado SENESCYT.",
      idTypeLabel: "Tipo de identificación",
      idNumberLabel: "Número",
      idDocTitle: "Documento de identidad",
      idNumberPh: "Número de documento",
      idTypeCedulaOpt: "Cédula",
      idTypePasaporteOpt: "Pasaporte",
      passportDataPage: "Pasaporte – página de datos",
      takePhoto: "Tomar foto", uploadFile: "Subir archivo", removeFile: "Quitar",
      fileLoaded: "Archivo cargado", fileTooLarge: "Archivo demasiado grande",
      rucOpt: "RUC (opcional)",
      cityPlaceholder: "Seleccione su ciudad",
      loginLead: "Acceda a su panel Agendik.",
      forgot: "¿Olvidó su contraseña?",
      resetTitle: "Restablecer contraseña",
      resetLead: "Le enviaremos un enlace para restablecer su contraseña (válido 1 hora).",
      resetEmailLbl: "Email de su cuenta médico",
      resetSubmit: "Enviar enlace",
      resetSent: "Si su email existe, le enviamos un enlace para restablecer su contraseña. El enlace es válido por 1 hora.",
      resetBack: "Volver",
      resetCancel: "Cancelar",
      rucLabel: "RUC para facturación (opcional)",
      rucHint: "13 dígitos. Puedes completarlo más tarde desde Mi perfil.",
      errIdRequired: "Debes ingresar tu número de identificación.",
      errCedulaFormat: "La cédula debe tener 10 dígitos.",
      errRucFormat: "El RUC debe tener 13 dígitos.",
      referralLabel: "¿Tienes un código de referido? (opcional)",
      trialInfo: "30 días gratis, sin tarjeta. Al final de la prueba, agregue su método de pago para continuar: $49/mes.",
      pwHelper: "Mínimo 8 caracteres",
      cardLabel: "Tarjeta bancaria (registrada, no cobrada durante los 30 días)",
      cardNumberLabel: "Número de tarjeta",
      cardExpiryLabel: "Fecha de vencimiento (MM/AA)",
      cardCvcLabel: "CVC (código de seguridad al dorso)",
      cardHolderLabel: "Nombre del titular de la tarjeta",
      cardHolderPh: "Ej: Frederic Thomas",
      errCardIncomplete: "Complete todos los campos de la tarjeta (número, fecha, CVC, titular).",
      errCardHolderRequired: "Ingrese el nombre del titular de la tarjeta.",
      chargeNotice: "Su tarjeta no será cobrada hasta el {date}. Puede cancelar en 1 clic hasta 24 horas antes de esa fecha, sin ningún cargo.",
      acceptTermsHtml: 'Acepto los <a href="/legal/terminos" target="_blank" rel="noopener" class="text-blue-600 hover:underline">Términos y Condiciones</a> y la <a href="/legal/privacidad" target="_blank" rel="noopener" class="text-blue-600 hover:underline">Política de Privacidad</a>',
      errRequired: "Completa todos los campos obligatorios (incluyendo SENESCYT)",
      errPwShort: "La contraseña debe tener al menos 8 caracteres",
      errPwMismatch: "Las contraseñas no coinciden",
      errAcceptTerms: "Debes aceptar los Términos y Condiciones",
      registered: "Registro recibido · pendiente de verificación",
    },
    doctorDash: {
      welcome: "Bienvenido/a Dr.", trial: "Prueba gratis", active: "Suscripción activa",
      cancelled: "Suscripción cancelada", pastDue: "Pago pendiente", unpaid: "Impago (pausado)",
      trialEnds: "Prueba termina",
      upgradeCta: "Activar suscripción ($49/mes)", upcoming: "Próximas citas",
      past: "Historial", noAppointments: "No tienes citas todavía.",
      availability: "Mi disponibilidad", profile: "Mi perfil",
      save: "Guardar", cancel: "Cancelar cita", patient: "Paciente",
      day: "Día", slots: "Horarios (30 min)", addSlot: "Añadir horario",
      remove: "Quitar", saveAvailability: "Guardar disponibilidad",
    },
    admin: {
      title: "Panel de administración", loginTitle: "Login Admin",
      email: "Email", password: "Contraseña", login: "Ingresar",
      doctors: "Doctores", appointments: "Citas", revenue: "Ingresos",
      activeSubs: "Suscripciones activas", trialDocs: "En prueba",
      totalDocs: "Total doctores", totalApts: "Total citas",
      mrr: "MRR mensual", totalCollected: "Total recaudado",
      toggle: "Activar/Desactivar",
    },
    partner: {
      title: "Conviértase en Socio referidor",
      subtitle: "$9 USD al mes por cada médico referido que paga su suscripción (después de su mes gratis), transferidos a su cuenta bancaria en Ecuador.",
      fullName: "Nombre completo",
      phoneOpt: "Teléfono (opcional)",
      payment: "Método de pago (Wise / IBAN / cuenta bancaria)",
      paymentPh: "Ej: Wise wise@email.com  ó  Banco Pichincha 22001...",
      acceptPrefix: "Acepto los",
      acceptLink: "términos del programa de referidos",
      submit: "Enviar solicitud",
      haveAccount: "¿Ya tienes cuenta?",
      login: "Ingresar",
      received: "Solicitud recibida",
      receivedMsg: "Le contactaremos en 48h con su código de referido.",
      backHome: "Volver al inicio",
    },
    docFields: {
      paymentsTitle: "Medios de pago aceptados en consulta",
      pmCredit: "Tarjeta de crédito", pmDebit: "Tarjeta de débito",
      pmCash: "Efectivo", pmTransfer: "Transferencia",
      priceLabel: "Precio de la consulta ($)", pricePlaceholder: "Ej: 35",
      insurancesTitle: "Seguros aceptados",
      insurancesAdd: "Añadir un seguro (Ej: Salud SA, Ecuasanitas)",
      iessLabel: "Acepto IESS",
      presentationLabel: "Presentación de su especialidad",
      presentationHelp: "Describa su especialidad, sus servicios y su experiencia. Ej: Pediatra con 10 años de experiencia, control del niño sano, vacunación.",
      presentationCounter: "{n}/300 caracteres",
      linkForbidden: "No se permiten enlaces ni redes sociales en el perfil público. Sus pacientes reservan directamente en Agendik.",
      publicPaymentTitle: "Medios de pago aceptados",
      publicInsurancesTitle: "Seguros aceptados",
      publicPriceLabel: "Consulta desde",
      add: "Añadir", remove: "Quitar",
    },
    days: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
    status: { confirmed: "Confirmada", completed: "Completada", cancelled: "Cancelada",
              pending: "Pendiente", pending_verification: "Pendiente",
              no_show: "No asistió", rescheduled: "Reprogramada" },
    common: { loading: "Cargando…", city: "Ciudad", specialty: "Especialidad", all: "Todas", back: "Volver", searchPlaceholder: "Buscar…", noResults: "Sin resultados" },
  },
  fr: {
    nav: { search: "Trouver un médecin", doctorLogin: "Je suis médecin", patientLogin: "Je suis patient", patientSpace: "Mon espace", admin: "Admin", dashboard: "Tableau", logout: "Déconnexion", downloadApp: "Télécharger l'application" },
    home: {
      title: "Rendez-vous médical en 2 clics",
      subtitle: "Trouvez le meilleur médecin en Équateur. Réservez en quelques secondes.",
      searchCta: "Chercher un médecin",
      doctorCta: "Je suis médecin, commencer gratuitement",
      trialBadge: "30 jours gratuits, sans carte · À la fin, ajoutez votre moyen de paiement : $49/mois",
      cityLabel: "Ville", specialtyLabel: "Spécialité", selectCity: "Choisir une ville",
      selectSpecialty: "Toutes les spécialités",
      featuresTitle: "Pourquoi Agendik ?",
      f1t: "Réservation instantanée", f1d: "Confirmez votre rendez-vous en 2 clics.",
      f2t: "Médecins vérifiés", f2d: "Professionnels certifiés partout en Équateur.",
      useLocation: "Utiliser ma position",
      f3t: "Rappels par email", f3d: "Recevez confirmation et rappel 24h avant.",
      doctorsTitle: "Pour les médecins", doctorsSub: "Gérez votre agenda et développez votre cabinet.",
      trialCard: "49$/mois · 30 jours gratuits",
      priceMonth: "/mois",
      trialFull: "30 jours gratuits, sans carte. À la fin de l'essai, ajoutez votre moyen de paiement pour continuer : $49/mois.",
      benefit1: "Agenda configurable (5 à 60 min)",
      benefit2: "Profil public en Équateur · 30 villes",
      benefit3: "Rappels automatiques",
      addToCalendar: "Ajouter à mon calendrier",
      dobLabel: "Date de naissance du membre de la famille (JJ/MM/AAAA)",
      calendarTab: "Mon calendrier",
      addManual: "Ajouter un RDV manuel",
      pause: "Pause",
      today: "Aujourd'hui",
      confirmed: "Confirmé",
      pending: "En attente",
    },
    footer: { terms: "Conditions générales", privacy: "Politique de confidentialité", manage: "Gérer mon rendez-vous", becomePartner: "Devenir Socio referidor", about: "À propos" },
    search: { title: "Trouvez votre médecin", resultsTitle: "Résultats", noResults: "Aucun médecin trouvé.", viewProfile: "Voir profil" },
    profile: { about: "À propos", specialty: "Spécialité", clinic: "Clinique", address: "Adresse", phone: "Téléphone",
      availableSlots: "Créneaux disponibles", pickDate: "Choisir une date", noSlots: "Aucun créneau disponible.", bookNow: "Réserver" },
    booking: {
      title: "Confirmez votre RDV", step1: "Choisir un créneau", step2: "Vos infos",
      fullName: "Nom complet",
      holderName: "Votre nom complet (titulaire du compte)",
      email: "Email",
      holderEmail: "Votre email (vous recevrez la confirmation)",
      phone: "Téléphone",
      holderPhone: "Votre téléphone",
      notes: "Notes (facultatif)",
      confirm: "Confirmer", back: "Retour", success: "RDV confirmé !", successMsg: "Détails envoyés par email.", close: "Fermer",
      manageHint: "Pour voir ou annuler votre RDV, utilisez le lien que nous vous avons envoyé par email, ou 'Gérer mon rendez-vous'.",
    },
    doctorAuth: {
      loginTitle: "Connexion Médecin", registerTitle: "Inscription Médecin",
      email: "Email", password: "Mot de passe", passwordConfirm: "Confirmer le mot de passe",
      login: "Se connecter", register: "Créer un compte",
      switchRegister: "Pas de compte ? S'inscrire", switchLogin: "Déjà un compte ? Se connecter",
      fullName: "Nom complet", specialty: "Spécialité",
      specialtyPlaceholder: "Sélectionnez votre spécialité",
      clinicName: "Clinique",
      address: "Adresse", city: "Ville", phone: "Téléphone",
      photoUrl: "Photo de profil (facultatif)", uploadPhoto: "Télécharger une photo de profil",
      senescyt: "Numéro d'enregistrement SENESCYT",
      diploma: "Titre / certificat SENESCYT",
      uploadDiploma: "Téléverser le titre",
      uploadDiplomaHint: "Photo ou PDF où l'on voit le numéro d'enregistrement.",
      cedulaFront: "Carte d'identité – recto",
      cedulaBack: "Carte d'identité – verso",
      uploadCedulaFront: "Téléverser le recto",
      uploadCedulaBack: "Téléverser le verso",
      cedulaFrontHint: "Photo nette (JPG/PNG, max 5 Mo).",
      cedulaBackHint: "Photo nette (JPG/PNG, max 5 Mo).",
      changeFile: "Changer",
      cedulaHelper: "Les photos de la cédula restent privées : seul l'administrateur y accède via un lien signé temporaire.",
      errCedulaRequired: "Vous devez téléverser la cédula (recto et verso).",
      errDiplomaRequired: "Vous devez téléverser le titre / certificat SENESCYT.",
      idTypeLabel: "Type d'identification",
      idNumberLabel: "Numéro",
      idDocTitle: "Pièce d'identité",
      idNumberPh: "Numéro de pièce d'identité",
      idTypeCedulaOpt: "Carte d'identité",
      idTypePasaporteOpt: "Passeport",
      passportDataPage: "Passeport – page d'identité",
      takePhoto: "Prendre une photo", uploadFile: "Téléverser un fichier", removeFile: "Retirer",
      fileLoaded: "Fichier chargé", fileTooLarge: "Fichier trop volumineux",
      rucOpt: "RUC (optionnel)",
      cityPlaceholder: "Sélectionnez votre ville",
      loginLead: "Accédez à votre tableau de bord Agendik.",
      forgot: "Mot de passe oublié ?",
      resetTitle: "Réinitialiser le mot de passe",
      resetLead: "Nous vous enverrons un lien pour réinitialiser votre mot de passe (valable 1 heure).",
      resetEmailLbl: "Email de votre compte médecin",
      resetSubmit: "Envoyer le lien",
      resetSent: "Si votre email existe, nous vous avons envoyé un lien pour réinitialiser votre mot de passe. Le lien est valable 1 heure.",
      resetBack: "Retour",
      resetCancel: "Annuler",
      rucLabel: "RUC pour facturation (optionnel)",
      rucHint: "13 chiffres. Modifiable ensuite dans Mon profil.",
      errIdRequired: "Vous devez saisir votre numéro d'identification.",
      errCedulaFormat: "La cédula doit contenir 10 chiffres.",
      errRucFormat: "Le RUC doit contenir 13 chiffres.",
      referralLabel: "As-tu un code de parrainage ? (facultatif)",
      trialInfo: "30 jours gratuits, sans carte. À la fin de l'essai, ajoutez votre moyen de paiement pour continuer : $49/mois.",
      pwHelper: "Minimum 8 caractères",
      cardLabel: "Carte bancaire (enregistrée, non débitée pendant 30 jours)",
      cardNumberLabel: "Numéro de carte",
      cardExpiryLabel: "Date d'expiration (MM/AA)",
      cardCvcLabel: "CVC (code de sécurité au dos)",
      cardHolderLabel: "Nom du titulaire de la carte",
      cardHolderPh: "Ex : Frederic Thomas",
      errCardIncomplete: "Merci de compléter tous les champs de la carte (numéro, date, CVC, titulaire).",
      errCardHolderRequired: "Merci d'indiquer le nom du titulaire de la carte.",
      chargeNotice: "Votre carte ne sera pas débitée avant le {date}. Vous pouvez annuler en 1 clic jusqu'à 24 heures avant cette date, sans aucun frais.",
      acceptTermsHtml: 'J\'accepte les <a href="/legal/terminos" target="_blank" rel="noopener" class="text-blue-600 hover:underline">Conditions générales</a> et la <a href="/legal/privacidad" target="_blank" rel="noopener" class="text-blue-600 hover:underline">Politique de confidentialité</a>',
      errRequired: "Merci de compléter tous les champs obligatoires (incluant SENESCYT)",
      errPwShort: "Le mot de passe doit contenir au moins 8 caractères",
      errPwMismatch: "Les mots de passe ne correspondent pas",
      errAcceptTerms: "Vous devez accepter les Conditions générales",
      registered: "Inscription reçue · en attente de vérification",
    },
    doctorDash: {
      welcome: "Bienvenue Dr.", trial: "Essai gratuit", active: "Abonnement actif",
      cancelled: "Abonnement annulé", pastDue: "Paiement en retard", unpaid: "Impayé (pausé)",
      trialEnds: "Fin de l'essai",
      upgradeCta: "Activer l'abonnement (49$/mois)", upcoming: "Prochains RDV", past: "Historique",
      noAppointments: "Aucun RDV pour le moment.", availability: "Ma disponibilité", profile: "Mon profil",
      save: "Enregistrer", cancel: "Annuler", patient: "Patient", day: "Jour", slots: "Créneaux (30 min)",
      addSlot: "Ajouter", remove: "Retirer", saveAvailability: "Enregistrer disponibilité",
    },
    admin: { title: "Tableau admin", loginTitle: "Connexion Admin", email: "Email", password: "Mot de passe",
      login: "Se connecter", doctors: "Médecins", appointments: "RDV", revenue: "Revenus",
      activeSubs: "Abonnements actifs", trialDocs: "En essai", totalDocs: "Total médecins",
      totalApts: "Total RDV", mrr: "MRR mensuel", totalCollected: "Total collecté", toggle: "Activer/Désactiver" },
    partner: {
      title: "Devenez Socio referidor",
      subtitle: "$9 USD par mois pour chaque médecin parrainé qui paie son abonnement (après son mois gratuit), versés par virement sur votre compte bancaire en Équateur.",
      fullName: "Nom complet",
      phoneOpt: "Téléphone (facultatif)",
      payment: "Méthode de paiement (Wise / IBAN / coordonnées bancaires)",
      paymentPh: "Ex : Wise wise@email.com  ou  Banque XX 22001...",
      acceptPrefix: "J'accepte les",
      acceptLink: "conditions du programme de parrainage",
      submit: "Envoyer la demande",
      haveAccount: "Déjà un compte ?",
      login: "Se connecter",
      received: "Demande reçue",
      receivedMsg: "Nous vous contacterons sous 48 h avec votre code de parrainage.",
      backHome: "Retour à l'accueil",
    },
    docFields: {
      paymentsTitle: "Moyens de paiement acceptés en consultation",
      pmCredit: "Carte de crédit", pmDebit: "Carte de débit",
      pmCash: "Espèces", pmTransfer: "Virement",
      priceLabel: "Prix de la consultation ($)", pricePlaceholder: "Ex : 35",
      insurancesTitle: "Assurances acceptées",
      insurancesAdd: "Ajouter une assurance (Ex : Salud SA, Ecuasanitas)",
      iessLabel: "J'accepte l'IESS",
      presentationLabel: "Présentation de votre spécialité",
      presentationHelp: "Décrivez votre spécialité, vos services et votre expérience. Ex : Pédiatre avec 10 ans d'expérience, suivi de l'enfant sain, vaccination.",
      presentationCounter: "{n}/300 caractères",
      linkForbidden: "Les liens et réseaux sociaux ne sont pas autorisés sur le profil public. Vos patients réservent directement sur Agendik.",
      publicPaymentTitle: "Moyens de paiement acceptés",
      publicInsurancesTitle: "Assurances acceptées",
      publicPriceLabel: "Consultation à partir de",
      add: "Ajouter", remove: "Retirer",
    },
    days: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
    status: { confirmed: "Confirmé", completed: "Terminé", cancelled: "Annulé",
              pending: "En attente", pending_verification: "En attente",
              no_show: "Absent", rescheduled: "Reprogrammé" },
    common: { loading: "Chargement…", city: "Ville", specialty: "Spécialité", all: "Toutes", back: "Retour", searchPlaceholder: "Rechercher…", noResults: "Aucun résultat" },
  },
  en: {
    nav: { search: "Find Doctor", doctorLogin: "I'm a doctor", patientLogin: "I'm a patient", patientSpace: "My space", admin: "Admin", dashboard: "Dashboard", logout: "Log out", downloadApp: "Download app" },
    home: {
      title: "Medical appointments in 2 clicks",
      subtitle: "Find the best doctor across Ecuador. Book in seconds, no calls needed.",
      searchCta: "Search doctors",
      doctorCta: "I'm a doctor, start free",
      trialBadge: "30 days free, no card · At the end add your payment method: $49/month",
      cityLabel: "City", specialtyLabel: "Specialty", selectCity: "Select city",
      selectSpecialty: "All specialties",
      featuresTitle: "Why Agendik?",
      f1t: "Instant booking", f1d: "Confirm your appointment in 2 clicks.",
      f2t: "Verified doctors", f2d: "Certified professionals across Ecuador.",
      useLocation: "Use my location",
      f3t: "Email reminders", f3d: "Confirmation + 24h reminder by email.",
      doctorsTitle: "For doctors", doctorsSub: "Manage your schedule and grow your practice.",
      trialCard: "$49/month · 30 days free",
      priceMonth: "/month",
      trialFull: "30 days free, no card required. At the end of the trial, add your payment method to continue: $49/month.",
      benefit1: "Configurable schedule (5 to 60 min)",
      benefit2: "Public profile across Ecuador · 30 cities",
      benefit3: "Automatic reminders",
      addToCalendar: "Add to calendar",
      dobLabel: "Family member date of birth (DD/MM/YYYY)",
      calendarTab: "My calendar",
      addManual: "Add manual appointment",
      pause: "Break",
      today: "Today",
      confirmed: "Confirmed",
      pending: "Pending",
    },
    footer: { terms: "Terms & Conditions", privacy: "Privacy Policy", manage: "Manage my booking", becomePartner: "Become a Socio referidor", about: "About us" },
    search: { title: "Find your doctor", resultsTitle: "Results", noResults: "No doctors found.", viewProfile: "View profile" },
    profile: { about: "About", specialty: "Specialty", clinic: "Clinic", address: "Address", phone: "Phone",
      availableSlots: "Available slots", pickDate: "Pick a date", noSlots: "No slots available.", bookNow: "Book now" },
    booking: {
      title: "Confirm your booking", step1: "Pick a slot", step2: "Your info",
      fullName: "Full name",
      holderName: "Your full name (account holder)",
      email: "Email",
      holderEmail: "Your email (you'll receive the confirmation)",
      phone: "Phone",
      holderPhone: "Your phone",
      notes: "Notes (optional)",
      confirm: "Confirm booking", back: "Back", success: "Booking confirmed!",
      successMsg: "Details sent to your email.", close: "Close",
      manageHint: "To view or cancel your appointment, use the link we emailed you or 'Manage my booking'.",
    },
    doctorAuth: {
      loginTitle: "Doctor Login", registerTitle: "Doctor Sign Up",
      email: "Email", password: "Password", passwordConfirm: "Confirm password",
      login: "Log in", register: "Create account",
      switchRegister: "No account? Sign up", switchLogin: "Already have an account? Log in",
      fullName: "Full name", specialty: "Specialty",
      specialtyPlaceholder: "Select your specialty",
      clinicName: "Clinic name",
      address: "Address", city: "City", phone: "Phone",
      photoUrl: "Profile photo (optional)", uploadPhoto: "Upload profile photo",
      senescyt: "SENESCYT registration number",
      diploma: "SENESCYT diploma / certificate",
      uploadDiploma: "Upload diploma",
      uploadDiplomaHint: "Photo or PDF showing the registration number.",
      cedulaFront: "ID card – front",
      cedulaBack: "ID card – back",
      uploadCedulaFront: "Upload front",
      uploadCedulaBack: "Upload back",
      cedulaFrontHint: "Sharp photo (JPG/PNG, max 5 MB).",
      cedulaBackHint: "Sharp photo (JPG/PNG, max 5 MB).",
      changeFile: "Change",
      cedulaHelper: "ID card photos stay private: only the admin can view them via a temporary signed link.",
      errCedulaRequired: "You must upload the ID card (front and back).",
      errDiplomaRequired: "You must upload the SENESCYT diploma / certificate.",
      idTypeLabel: "Identification type",
      idNumberLabel: "Number",
      idDocTitle: "ID document",
      idNumberPh: "Document number",
      idTypeCedulaOpt: "ID card",
      idTypePasaporteOpt: "Passport",
      passportDataPage: "Passport – data page",
      takePhoto: "Take photo", uploadFile: "Upload file", removeFile: "Remove",
      fileLoaded: "File uploaded", fileTooLarge: "File too large",
      rucOpt: "RUC (optional)",
      cityPlaceholder: "Select your city",
      loginLead: "Sign in to your Agendik dashboard.",
      forgot: "Forgot your password?",
      resetTitle: "Reset password",
      resetLead: "We'll send you a link to reset your password (valid 1 hour).",
      resetEmailLbl: "Email of your doctor account",
      resetSubmit: "Send link",
      resetSent: "If your email exists, we've sent you a link to reset your password. The link is valid for 1 hour.",
      resetBack: "Back",
      resetCancel: "Cancel",
      rucLabel: "RUC for invoicing (optional)",
      rucHint: "13 digits. You can complete it later from Mi perfil.",
      errIdRequired: "You must enter your identification number.",
      errCedulaFormat: "Cédula must be 10 digits.",
      errRucFormat: "RUC must be 13 digits.",
      referralLabel: "Have a referral code? (optional)",
      trialInfo: "30 days free, no card required. At the end of the trial, add your payment method to continue: $49/month.",
      pwHelper: "Minimum 8 characters",
      cardLabel: "Payment card (stored, not charged for 30 days)",
      cardNumberLabel: "Card number",
      cardExpiryLabel: "Expiry date (MM/YY)",
      cardCvcLabel: "CVC (security code on the back)",
      cardHolderLabel: "Cardholder name",
      cardHolderPh: "e.g. Frederic Thomas",
      errCardIncomplete: "Please complete all card fields (number, expiry, CVC, cardholder).",
      errCardHolderRequired: "Please enter the cardholder name.",
      chargeNotice: "Your card won't be charged until {date}. You can cancel in 1 click up to 24 hours before that date, with no charge.",
      acceptTermsHtml: 'I accept the <a href="/legal/terminos" target="_blank" rel="noopener" class="text-blue-600 hover:underline">Terms & Conditions</a> and the <a href="/legal/privacidad" target="_blank" rel="noopener" class="text-blue-600 hover:underline">Privacy Policy</a>',
      errRequired: "Please complete all required fields (including SENESCYT)",
      errPwShort: "Password must be at least 8 characters",
      errPwMismatch: "Passwords do not match",
      errAcceptTerms: "You must accept the Terms & Conditions",
      registered: "Registration received · awaiting verification",
    },
    doctorDash: {
      welcome: "Welcome Dr.", trial: "Free trial", active: "Subscription active",
      cancelled: "Subscription cancelled", pastDue: "Payment overdue", unpaid: "Unpaid (paused)",
      trialEnds: "Trial ends",
      upgradeCta: "Activate subscription ($49/mo)", upcoming: "Upcoming appointments",
      past: "History", noAppointments: "No appointments yet.", availability: "My availability",
      profile: "My profile", save: "Save", cancel: "Cancel", patient: "Patient",
      day: "Day", slots: "Slots (30 min)", addSlot: "Add slot", remove: "Remove",
      saveAvailability: "Save availability",
    },
    admin: { title: "Admin Panel", loginTitle: "Admin Login", email: "Email", password: "Password",
      login: "Log in", doctors: "Doctors", appointments: "Appointments", revenue: "Revenue",
      activeSubs: "Active subscribers", trialDocs: "On trial", totalDocs: "Total doctors",
      totalApts: "Total appointments", mrr: "Monthly MRR", totalCollected: "Total collected", toggle: "Activate/Deactivate" },
    partner: {
      title: "Become an Socio referidor",
      subtitle: "$9 USD per month for each referred doctor who pays their subscription (after their free month), transferred to your bank account in Ecuador.",
      fullName: "Full name",
      phoneOpt: "Phone (optional)",
      payment: "Payment method (Wise / IBAN / bank details)",
      paymentPh: "e.g. Wise wise@email.com  or  Bank XX 22001...",
      acceptPrefix: "I accept the",
      acceptLink: "referral program terms",
      submit: "Send request",
      haveAccount: "Already have an account?",
      login: "Log in",
      received: "Request received",
      receivedMsg: "We'll contact you within 48h with your referral code.",
      backHome: "Back to home",
    },
    docFields: {
      paymentsTitle: "Payment methods accepted in consultation",
      pmCredit: "Credit card", pmDebit: "Debit card",
      pmCash: "Cash", pmTransfer: "Bank transfer",
      priceLabel: "Consultation price ($)", pricePlaceholder: "e.g. 35",
      insurancesTitle: "Accepted insurances",
      insurancesAdd: "Add an insurance (e.g. Salud SA, Ecuasanitas)",
      iessLabel: "I accept IESS",
      presentationLabel: "Presentation of your specialty",
      presentationHelp: "Describe your specialty, services and experience. E.g. Pediatrician with 10 years of experience, healthy child care, vaccinations.",
      presentationCounter: "{n}/300 characters",
      linkForbidden: "Links and social networks are not allowed on the public profile. Your patients book directly on Agendik.",
      publicPaymentTitle: "Accepted payment methods",
      publicInsurancesTitle: "Accepted insurances",
      publicPriceLabel: "Consultation from",
      add: "Add", remove: "Remove",
    },
    days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    status: { confirmed: "Confirmed", completed: "Completed", cancelled: "Cancelled",
              pending: "Pending", pending_verification: "Pending",
              no_show: "No-show", rescheduled: "Rescheduled" },
    common: { loading: "Loading…", city: "City", specialty: "Specialty", all: "All", back: "Back", searchPlaceholder: "Search…", noResults: "No results" },
  },
};

export const MEDICAL_SPECIALTIES = [
  "Cardiología", "Cirugía General", "Cirugía Plástica", "Dermatología",
  "Endocrinología", "Fisioterapia", "Gastroenterología", "Ginecología",
  "Hematología", "Medicina General", "Medicina Interna", "Nefrología",
  "Neumología", "Neurología", "Nutrición", "Odontología", "Oftalmología",
  "Oncología", "Otorrinolaringología", "Pediatría", "Psicología",
  "Psiquiatría", "Reumatología", "Traumatología y Ortopedia", "Urología",
];
// Legacy alias — keep imports working across the codebase.
export const SPECIALTIES = MEDICAL_SPECIALTIES;

// Display labels per language. DB stores the canonical Spanish name.
// Only the "Todas" / "Toutes" / "All" pseudo-value is truly translated.
export const SPECIALTY_ALL_LABEL = { es: "Todas", fr: "Toutes", en: "All" };
const _FR = {
  "Cardiología": "Cardiologie", "Cirugía General": "Chirurgie générale",
  "Cirugía Plástica": "Chirurgie plastique", "Dermatología": "Dermatologie",
  "Endocrinología": "Endocrinologie", "Fisioterapia": "Kinésithérapie",
  "Gastroenterología": "Gastro-entérologie", "Ginecología": "Gynécologie",
  "Hematología": "Hématologie", "Medicina General": "Médecine générale",
  "Medicina Interna": "Médecine interne", "Nefrología": "Néphrologie",
  "Neumología": "Pneumologie", "Neurología": "Neurologie",
  "Nutrición": "Nutrition", "Odontología": "Dentiste",
  "Oftalmología": "Ophtalmologie", "Oncología": "Oncologie",
  "Otorrinolaringología": "ORL", "Pediatría": "Pédiatrie",
  "Psicología": "Psychologie", "Psiquiatría": "Psychiatrie",
  "Reumatología": "Rhumatologie",
  "Traumatología y Ortopedia": "Traumatologie et orthopédie",
  "Urología": "Urologie",
};
const _EN = {
  "Cardiología": "Cardiology", "Cirugía General": "General Surgery",
  "Cirugía Plástica": "Plastic Surgery", "Dermatología": "Dermatology",
  "Endocrinología": "Endocrinology", "Fisioterapia": "Physical Therapy",
  "Gastroenterología": "Gastroenterology", "Ginecología": "Gynecology",
  "Hematología": "Hematology", "Medicina General": "General Medicine",
  "Medicina Interna": "Internal Medicine", "Nefrología": "Nephrology",
  "Neumología": "Pulmonology", "Neurología": "Neurology",
  "Nutrición": "Nutrition", "Odontología": "Dentistry",
  "Oftalmología": "Ophthalmology", "Oncología": "Oncology",
  "Otorrinolaringología": "ENT", "Pediatría": "Pediatrics",
  "Psicología": "Psychology", "Psiquiatría": "Psychiatry",
  "Reumatología": "Rheumatology",
  "Traumatología y Ortopedia": "Trauma & Orthopedics",
  "Urología": "Urology",
};
export const specialtyLabel = (name, lang) => {
  if (!name) return "";
  if (lang === "fr") return _FR[name] || name;
  if (lang === "en") return _EN[name] || name;
  return name;
};
// Deprecated - kept for backwards compat; use ECUADOR_CITIES from data/cities.js
export { CITY_NAMES as CITIES } from "../data/cities";
